const ITEMS = ["SUSHI FUSION", "ROMA CINECITTÀ", "METRO SUBAUGUSTA", "MENÙ ALLA CARTA", "BAIANEIRA"];

export const Marquee = () => (
  <section
    aria-label="Baianeira Sushi Fusion"
    className="relative overflow-hidden border-y border-[#D4AF37]/20 bg-[#0A1F14]/50 py-5"
  >
    <div className="animate-marquee flex w-max [animation-direction:reverse]">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={`${copy}-${i}`} className="flex items-center">
              <span className="whitespace-nowrap px-6 font-display text-sm tracking-[0.35em] text-[#D4AF37]/85 md:px-10 md:text-base">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);

export default Marquee;
